// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f3f4f6;
}

.forgot-password-back-home {
  position: absolute;
  top: 1.75rem;
  left: 2rem;
  color: #6b7280;
  font-size: 1.2rem;
  text-decoration: none;
  transition: color 0.15s;
}

.forgot-password-back-home:hover {
  color: #f97316;
}

.forgot-password-card {
  background-color: #fffdfc;
  padding: 3rem;
  border-radius: 0.8rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 40rem;
  text-align: center;
}

.forgot-password-card h1 {
  color: #2c3948;
  font-size: 2.4rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

.forgot-password-subtitle {
  color: #2c3948;
  font-size: 1.6rem;
  margin-bottom: 2rem;
}

.forgot-password-card .form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

.forgot-password-card .form-group label {
  display: block;
  color: #2c3948;
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
}

.forgot-password-card .form-group input {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 1.5rem;
  color: #2c3948;
  box-sizing: border-box;
}

.forgot-password-card .form-group input:focus {
  outline: none;
  border-color: #f97316;
}

.forgot-password-card .form-actions {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}

.forgot-password-footer {
  margin-top: 2rem;
  color: #6b7280;
  font-size: 1.4rem;
}

.forgot-password-back-login {
  color: #f97316;
  font-size: 1.4rem;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s;
}

.forgot-password-back-login:hover {
  color: #ea580c;
}

.forgot-password-card .error-message {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
  font-size: 1.4rem;
}

.forgot-password-card .success-message {
  background-color: #dcfce7;
  color: #166534;
  padding: 1rem;
  border-radius: 0.5rem;
  margin: 1rem 0;
  font-size: 1.4rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":[".forgot-password-container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f3f4f6;\n}\n\n.forgot-password-back-home {\n  position: absolute;\n  top: 1.75rem;\n  left: 2rem;\n  color: #6b7280;\n  font-size: 1.2rem;\n  text-decoration: none;\n  transition: color 0.15s;\n}\n\n.forgot-password-back-home:hover {\n  color: #f97316;\n}\n\n.forgot-password-card {\n  background-color: #fffdfc;\n  padding: 3rem;\n  border-radius: 0.8rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 40rem;\n  text-align: center;\n}\n\n.forgot-password-card h1 {\n  color: #2c3948;\n  font-size: 2.4rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n}\n\n.forgot-password-subtitle {\n  color: #2c3948;\n  font-size: 1.6rem;\n  margin-bottom: 2rem;\n}\n\n.forgot-password-card .form-group {\n  margin-bottom: 1.5rem;\n  text-align: left;\n}\n\n.forgot-password-card .form-group label {\n  display: block;\n  color: #2c3948;\n  font-size: 1.4rem;\n  margin-bottom: 0.8rem;\n}\n\n.forgot-password-card .form-group input {\n  width: 100%;\n  padding: 1.2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  font-size: 1.5rem;\n  color: #2c3948;\n  box-sizing: border-box;\n}\n\n.forgot-password-card .form-group input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.forgot-password-card .form-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5rem;\n}\n\n.forgot-password-footer {\n  margin-top: 2rem;\n  color: #6b7280;\n  font-size: 1.4rem;\n}\n\n.forgot-password-back-login {\n  color: #f97316;\n  font-size: 1.4rem;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.15s;\n}\n\n.forgot-password-back-login:hover {\n  color: #ea580c;\n}\n\n.forgot-password-card .error-message {\n  background-color: #fee2e2;\n  color: #b91c1c;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n  font-size: 1.4rem;\n}\n\n.forgot-password-card .success-message {\n  background-color: #dcfce7;\n  color: #166534;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin: 1rem 0;\n  font-size: 1.4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
